module.exports = __webpack_public_path__ + "img/INF-A-2-III.f7f0bfbf.png";